module.exports = __webpack_public_path__ + "static/img/footer-pic-1.fdbbfa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/home/footer-pic-1.png
// module id = YwBs
// module chunks = 0 1